import { GetProductionChartDataType } from '@vae/server/src/Charts/ProductionChart/getProductionChartData'
import { GroupingOptionsV2 } from '@vae/server/src/utils/arrays/types/GroupingOptions'
import React from 'react'
import useUser from '../../../../../contexts/hooks/useUser'
import BaseTooltip from '../../../components/baseTooltip/BaseTooltip'
import getTimeString from '../../../components/baseTooltip/getTimeString'

interface ProductionTooltipProps {
	activeElement: number
	isLoading: boolean
	timespan: GroupingOptionsV2
	labels: string[]
	tooltipData: any[]
	chartData: GetProductionChartDataType | undefined | null
	setActiveElement: React.Dispatch<React.SetStateAction<number>>
}

const ProductionTooltip: React.FC<ProductionTooltipProps> = ({
	activeElement,
	isLoading,
	timespan,
	labels,
	tooltipData,
	chartData,
	setActiveElement,
}) => {
	const { user } = useUser()

	const element = chartData?.exchangePrices.groupedData[activeElement]?.localTime

	if (!element) return null

	const selectedLabel = labels[activeElement]
	const adjustedTimespan = timespan === 'hour' ? 'day' : timespan
	const time = getTimeString(element, selectedLabel, adjustedTimespan, user?.language || 'fi')

	return (
		<BaseTooltip
			isLoading={isLoading}
			time={time}
			activeElement={activeElement}
			setActiveElement={setActiveElement}
			upperLimit={labels.length}
			tooltipData={tooltipData}
		/>
	)
}

export default ProductionTooltip
